import React from 'react';
import SEO from '../components/SEO';
import PortfolioHero from '../components/portfolio/PortfolioHero';
import PortfolioGrid from '../components/portfolio/PortfolioGrid';
import PortfolioStats from '../components/portfolio/PortfolioStats';

const Portfolio: React.FC = () => {
  return (
    <div className="min-h-screen bg-black">
      <SEO
        title="Our Work"
        description="Explore Bizani Media's portfolio: documentaries, branding, events coverage, and project documentation for NGOs, brands, and institutions across Zimbabwe."
        path="/work"
        keywords="portfolio, case studies, documentaries, Crediconnect, FOTE, ILO, Sustain, branding projects, event coverage, Zimbabwe"
      />
      <PortfolioHero />
      <PortfolioGrid />
      <PortfolioStats />
    </div>
  );
};

export default Portfolio;
